import type { PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';

type MenuItemTitleProps = PropsWithChildren<{
  className?: string;
}>

export const MenuItemTitle = ( { className, children }: MenuItemTitleProps ) => {
  return(
    <p className={ cn(
      'text-base font-semibold leading-[16px]',
      className
    ) }>
      { children }
    </p>
  )
}
MenuItemTitle.displayName = 'MenuItemTitle';
